import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import CompareArrows from '@material-ui/icons/CompareArrows';
import CheckIcon from '@material-ui/icons/Check';
import green from '@material-ui/core/colors/green';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import LinearProgress from '../../Utils/LinearProgress';
import { handleServerError } from '../../../Utils/Helper';
import { ADMIN_GROUP } from '../../../Utils/Constants';
import NOLSSyncAPI from '../../../API/NOLSSyncAPI';


const styles = theme => ({
  titleHead: {
    padding: '18px 8px 18px 0px'
  },
  divToolbar: {
    padding: '0px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px',
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  }
});

class AdminGeneralDefinitionsToolbar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      openError: false,
      alertMessage: ''
    };
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleUpdateGeneralDefinitionsSGE = () => {
    const nolsSyncAPI = new NOLSSyncAPI();
    this.setState({ loading: true })
    nolsSyncAPI.sendUpdateOrderAll().then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });

    return (
      <div className={classes.divToolbar}>

        <Typography className={classes.titleHead} variant='title' id='tableTitle'>
          {this.props.titleTableList}
        </Typography>

        {loading && <LinearProgress />}

        <div>
          {this.props.user.UserRoleType.indexOf(ADMIN_GROUP) < 0 ?
            null :
            <Tooltip title='Ligação ao NOLS' placement='bottom' >
              <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.handleUpdateGeneralDefinitionsSGE}>
                {success ? <CheckIcon /> : <CompareArrows />}
              </Button>
            </Tooltip>
          }

          <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />
        </div>

      </div>
    );
  }

};

AdminGeneralDefinitionsToolbar.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(AdminGeneralDefinitionsToolbar));


// WEBPACK FOOTER //
// ./src/components/Administration/AdminGeneralDefinitions/AdminGeneralDefinitionsToolbar.js